module.exports = __webpack_public_path__ + "files/41f162f25a9de393aa4ddae4fd9807a7.png";